// action types
export const START_GLOBAL_LOADING = "startGlobalLoading";
export const STOP_GLOBAL_LOADING = "stopGlobalLoading";

// mutation types
export const SET_GLOBAL_LOADING = "setGlobalLoading";

export default {
  state: {
    isGlobalLoading: false
  },
  getters: {
    /**
     * Get loading status
     * @param state
     * @return {*}
     * */
    globalLoading(state) {
      return state.isGlobalLoading;
    }
  },
  actions: {
    /**
     * Set loading status
     * @param state
     */
    [START_GLOBAL_LOADING](state) {
      state.commit(SET_GLOBAL_LOADING, true);
    },
    /**
     * Set loading status
     * @param state
     */
    [STOP_GLOBAL_LOADING](state) {
      state.commit(SET_GLOBAL_LOADING, false);
    }
  },
  mutations: {
    [SET_GLOBAL_LOADING](state, payload) {
      state.isGlobalLoading = payload;
    }
  }
};
